import { AbstractControl, ValidationErrors } from '@angular/forms';

export function nameValidator(control: AbstractControl): ValidationErrors | null {
  const raw = control.value || '';
  const trimmed = raw.trim();

  // Let `required` handle the empty case
  if (!trimmed) return null;

  // Fail only if the value contains characters other than letters and spaces
  if (!/^[a-zA-Z ]+$/.test(trimmed)) {
    return { pattern: true };
  }

  return null;
}